import React from "react";
import "./Unauthorized.css";

const Unauthorized: React.FC = () => {
  const year = new Date().getFullYear();
  const copyrightYear = year > 2017 ? `2017-${year}` : "2017";

  return (
    <div className="site-down">
      <div className="home">
        <div className="header" style={{ overflow: "hidden" }}>
          <div className="cardinal-logo float-left">
            <span className="cardinal-logo-img" style={{ fontSize: '24px', fontWeight: 'bold' }}>Cardinal Health</span>
          </div>
          <div className="logout-out-div pad-top-sm-2 float-right">
            <div className="clear-both float-right">
              <h3 className="text-align-right pad-top-sm-6">Centralized CSOS</h3>
            </div>
          </div>
        </div>
      </div>
      <div className="clear-both content">
        <div className="set-background">
          <div className="pad-left-lg-1 container-position">
            <div className="content-position unavailable-message">You have been successfully logged out.</div>
            <div className="restore-message">To reactivate your session, please login again.</div>
          </div>
          <div className="container-position margin-lg-3">
            <div className="content-position white-box pad">
              <div className="customer-service">Customer Service</div>
              <div className="question padding-top-sm-1">If you have an immediate need<br />please call customer service:</div>
              <div className="phone-number padding-top-sm-1">1-800-334-5529</div>
            </div>
          </div>
        </div>
        <div className="clear-both footer">
          <p id="footer-text" className="padding-top-left">&copy;{copyrightYear} Cardinal Health. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
